<template>
  <div v-if="filter" style="display: inline-block">
    <div v-if="filter.type === 'clear'">
      <span
        class="table-filter"
        uk-icon="icon: remove-filter; ratio: 0.8"
        @click="clearFilter"
      ></span>
    </div>
    <div v-else>
      <span uk-icon="icon: filter; ratio: 0.8" class="table-filter"></span>
      <div uk-dropdown="mode: click" :pos="position">
        <div v-if="filter.type === 'text'" class="uk-margin-remove uk-padding-remove filter">
          <label class="filter-label">
            <input
              v-model.trim="value"
              :key="temp"
              class="uk-input"
              type="search"
              placeholder="Поиск..."
            />
          </label>
        </div>
        <div v-if="filter.type === 'number'" class="uk-margin-remove uk-padding-remove filter">
          <label class="filter-label">
            <input
              v-model.number.trim="value"
              :key="temp"
              class="uk-input"
              type="number"
              placeholder="Поиск..."
            />
          </label>
        </div>
        <div v-if="filter.type === 'list'" class="uk-margin-remove uk-padding-remove filter">
          <div v-for="(val, iter) in filter.values" :key="iter">
            <label class="filter-label">
              <input
                :key="temp"
                class="uk-checkbox"
                type="checkbox"
                :value="val.value"
                :checked="checked"
                @change="check"
              />
              {{ val.text }}
            </label>
          </div>
        </div>
        <div v-if="filter.type === 'radio'" class="uk-margin-remove uk-padding-remove filter">
          <div v-for="(val, iter) in filter.values" :key="iter">
            <label class="filter-label">
              <input
                :key="temp"
                class="uk-radio"
                type="radio"
                :name="filter.field"
                :value="val.value"
                @click="radioClick"
              />
              {{ val.text }}
            </label>
          </div>
        </div>
        <div v-if="filter.type === 'date'" class="uk-margin-remove uk-padding-remove filter">
          <b-datepicker @input="dateSelect"></b-datepicker>
        </div>
        <div v-if="filter.type === 'dateRange'" class="uk-margin-remove uk-padding-remove filter">
          <b-datepicker range @input="dateSelect"></b-datepicker>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'b-table-filter',
  props: {
    filter: {
      type: Object,
      default: null
    },
    isNeedToClear: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    value: '',
    checked: false,
    temp: 1
  }),
  computed: {
    position() {
      return this.filter.position ? this.filter.position : 'right-top'
    }
  },
  watch: {
    value(val) {
      this.$emit('filtered', val)
    },
    isNeedToClear() {
      this.value = ''
      this.temp += 1
    }
  },
  methods: {
    check(val) {
      if (val.target.checked) {
        this.value === '' ? (this.value = val.target.value) : (this.value += '@' + val.target.value)
      } else {
        this.value = this.value.replace('@' + val.target.value, '')
        this.value = this.value.replace(val.target.value + '@', '')
        this.value = this.value.replace(val.target.value, '')
      }
    },
    radioClick(val) {
      this.value = val.target.value
    },
    clearFilter() {
      this.$emit('clearFilter')
    },
    dateSelect(val) {
      this.value = val
    }
  }
}
</script>

<style lang="scss" scoped>
.uk-dropdown {
  filter: drop-shadow(3px 3px 2px rgba(0, 0, 0, 0.2));
}

.filter {
  &-label {
    display: flex;
    align-items: center;
    padding: 7px 0;
    font-weight: 500;
    font-size: 1rem;
    line-height: 1.375;
    color: #9b9b9b;

    [type='checkbox'],
    [type='radio'] {
      margin-top: 0px;
      margin-right: 15px;
      flex-shrink: 0;
    }
  }
}
</style>
